import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    leftnavshow:1,
    commitread:0,
    tipsread:0,
    firstdo:-1,
    token:'',
    examid:0,
    userexaminfo:'',
    logincodeshow:false,
    logincodestatus:false,
    baseUrl:'https://ksgl.zzydtec.com',
    host:'https://ksgl.zzydtec.com'
  },
  mutations: {
    modifyshow(state,msg){
      state.leftnavshow=msg
    },
    modifycommitread(state,value){
      state.commitread=value
    },
    modifytipsread(state,value){
      state.tipsread=value
    },
    modifyfirstdo(state,value){
      state.firstdo=value
    },
    updateToken(state,value){
      state.token=value
    },
    updateExamId(state,value){
      state.examid=value
    },
    updateUserexaminfo(state,value){
      state.userexaminfo=value
    },
    updateLogincodeshow(state,value){
      state.logincodeshow=value
    },
    updateLogincodestatus(state,value){
      state.logincodestatus=value
    },
    setBaseUrl(state,value){
      state.baseUrl=value
    },
  },
  actions: {
  },
  modules: {
  }
})
